import React from 'react';
import { formatCurrency, formatNumber, formatPercent, formatFrequency, formatCostPerConversation } from '../utils/formatters';

const CampaignTable = ({ campaigns, currency = 'BRL' }) => {
  if (!campaigns || campaigns.length === 0) {
    return (
      <div className="table-card">
        <h3 className="chart-title">Performance por Campanha</h3>
        <p style={{ textAlign: 'center', color: 'var(--muted)', padding: '20px' }}>
          Nenhuma campanha encontrada
        </p>
      </div>
    );
  }

  return (
    <div className="table-card">
      <h3 className="chart-title">Performance por Campanha</h3>
      <table className="data-table">
        <thead>
          <tr>
            <th>Campanha</th>
            <th>Gasto</th>
            <th>Conversas iniciadas</th>
            <th>Custo por conversa</th>
            <th>CPM</th>
            <th>Frequência</th>
            <th>CTR</th>
            <th>Impressões</th>
            <th>Cliques</th>
          </tr>
        </thead>
        <tbody>
          {campaigns.map((campaign, index) => (
            <tr key={index}>
              <td className="col-campaign">{campaign.name}</td>
              <td>{formatCurrency(campaign.spend, currency)}</td>
              <td className="col-conversas">{formatNumber(campaign.conversations)}</td>
              <td className="col-custo">{formatCostPerConversation(campaign.costPerConversation, currency)}</td>
              <td>{formatCurrency(campaign.cpm, currency)}</td>
              <td>{formatFrequency(campaign.frequency)}</td>
              <td>{formatPercent(campaign.ctr)}</td>
              <td>{formatNumber(campaign.impressions)}</td>
              <td>{formatNumber(campaign.clicks)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CampaignTable;
